// eslint-disable-next-line import/no-extraneous-dependencies
import { useJsApiLoader } from "@react-google-maps/api";
import { useCallback } from "react";

const LIBRARIES = ["geocoding", "places"];

let loaderPromise = null;

export const useGeocoder = () => {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_PLACES_API_KEY,
    libraries: LIBRARIES,
  });
  if (!loaderPromise) {
    loaderPromise = new Promise((resolve) => {
      const checkLoaded = () => {
        if (window.google?.maps?.Geocoder) {
          resolve();
        } else {
          setTimeout(checkLoaded, 100);
        }
      };
      checkLoaded();
    });
  }
  const waitUntilLoaded = async () => {
    if (loadError) {
      console.error("Google Maps API failed to load:", loadError);
      throw new Error("Google Maps API failed to load");
    }
    if (isLoaded && window.google?.maps?.Geocoder) {
      return;
    }
    await loaderPromise;
  };
  const geocodeInternal = useCallback(async (request) => {
    await waitUntilLoaded();
    return new Promise((resolve, reject) => {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ ...request, language: "en" }, (results, status) => {
        if (
          status === window.google.maps.GeocoderStatus.OK ||
          status === window.google.maps.GeocoderStatus.ZERO_RESULTS
        ) {
          resolve({ results, status });
        } else {
          reject(new Error(`Geocoding failed with status: ${status}`));
        }
      });
    });
  }, []);
  const findByLatLng = useCallback(
    async (latlng) => {
      const [lat, lng] = latlng.split(",").map(Number);
      return geocodeInternal({ location: { lat, lng } });
    },
    [geocodeInternal]
  );
  const findByAddress = useCallback(
    async (address) => geocodeInternal({ address }),
    [geocodeInternal]
  );
  return { isLoaded, loadError, findByAddress, findByLatLng };
};
